const withDialog = (Component) => ({
    show,
    ...rest
}) => {    
    if (!show) return null

    return <Component show={show} {...rest}/>
}

export default withDialog